import { render, staticRenderFns } from "./vote-notice.vue?vue&type=template&id=33db91de&scoped=true&"
import script from "./vote-notice.vue?vue&type=script&lang=js&"
export * from "./vote-notice.vue?vue&type=script&lang=js&"
import style0 from "./vote-notice.vue?vue&type=style&index=0&id=33db91de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db91de",
  null
  
)

export default component.exports